
export default {
  name: 'nav-menu',
  // #[end]
  props: {
    title: {
      type: String,
      default: '同花顺',
    },
    backgroundColor: {
      type: String,
      default: '#fff',
    },
    needTopHeight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isAndroid: window.getPlatform() === 'gphone',
    };
  },
  computed: {
    navHeight: function navHeight() {
      return '11.733vw';
    },
    height: function height() {
      return '23.466vw';
    },
    navPadding: function navPadding() {
      return '11.733vw;';
    },
  },
  methods: {},
};
